<div *ngIf="status"
    class="status-square"
    [title]="'shared.status.' + status | translate"
    [class.status-square-small]="small"
    [ngClass]="getClassName()">
    {{ 'shared.status.' + status | translate }}
</div>
